module.exports = __webpack_public_path__ + "static/4-fcc3ee695539416febba0757deda43cd.jpg";